export default {
    // 验车详细查询
    selectCarInspectionListByLinkId:
        "/gateway/huilian/carInspectioncs/selectCarInspectionListByLinkId",
    CXHselectCarInspectionListByLinkId:
        "/gateway/huilian/carInspectioncs/selectCarInspectionListByLinkId",
};



// WEBPACK FOOTER //
// ./src/carBillDetails/index/api.js